// eslint-disable-next-line no-unused-vars
import { gsap } from 'gsap';
export default {
  name: 'PzLoading',
  data: function data() {
    return {
      text: null,
      spinner: null,
      background: null,
      fullscreen: true,
      visible: false,
      customClass: ''
    };
  },
  computed: {
    image: function image() {
      return require("@/assets/images/loader/" + this.spinner);
    }
  },
  methods: {
    handleAfterLeave: function handleAfterLeave() {
      this.$emit('after-leave');
    },
    setText: function setText(text) {
      this.text = text;
    }
  }
};